import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';
import { HttpWithCacheService } from '../http-with-cache.service';
import {
  CustomFieldList,
  CustomFieldDefinition,
  CustomFieldViewModel,
  IServerResponse,
  ProjectTemplate,
} from '@aksia/models';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService extends HttpWithCacheService {
  private api = inject(CedricApiService);
  private controller: string = 'CustomFields';

  constructor() {
    super();
  }

  updateCachedViewModel(
    cacheFn: (cachedData: CustomFieldViewModel) => CustomFieldViewModel,
  ) {
    this.updateCache<CustomFieldViewModel>(cacheFn);
  }

  getCustomFieldsAdminViewModel(
    forceHttp = false,
  ): Observable<CustomFieldViewModel> {
    return this.useCache(
      this.api.post(`${this.controller}/GetCustomFieldsAdminViewModel`, {}),
      { forceHttp },
    );
  }

  getCustomFieldsDefinitionById(id: number): Observable<CustomFieldDefinition> {
    return this.api.post(`${this.controller}/GetCustomFieldDefinitionById`, {
      id,
    });
  }

  addOrUpdateCustomFieldDefinition(
    customFieldDefinition: CustomFieldDefinition,
  ): Observable<
    IServerResponse & {
      customFieldDefinition?: CustomFieldDefinition;
    }
  > {
    const url =
      this.controller +
      (customFieldDefinition?.customFieldDefinitionId! > 0
        ? '/UpdateCustomFieldDefinition'
        : '/CreateCustomFieldDefinitionObject');
    return this.api.post(url, customFieldDefinition);
  }

  deleteCustomFieldDefinition(id: number): Observable<IServerResponse> {
    return this.api.post(`${this.controller}/DeleteCustomFieldDefinition`, {
      id,
    });
  }

  updateCustomFieldList(customFieldsList: CustomFieldList): Observable<
    IServerResponse & {
      updatedList?: CustomFieldList;
    }
  > {
    return this.api.post(
      `${this.controller}/UpdateCustomFieldList`,
      customFieldsList,
    );
  }

  deleteCustomFieldList(id: number): Observable<IServerResponse> {
    return this.api.post(`${this.controller}/DeleteCustomFieldList`, { id });
  }

  getWhereCustomFieldDefinitionIsUsed(
    id: number,
  ): Observable<{ templates: ProjectTemplate[] }> {
    return this.api.post(
      `${this.controller}/GetWhereCustomFieldDefinitionIsUsed`,
      { id },
    );
  }

  getWhereCustomFieldListIsUsed(
    id: number,
  ): Observable<{ customFieldDefinitions: CustomFieldDefinition[] }> {
    return this.api.post(`${this.controller}/GetWhereCustomFieldListIsUsed`, {
      id,
    });
  }
}
